module.exports = __webpack_public_path__ + "static/media/logo_stacked_white.3115f7df.svg";